<template>
  <div class="Datatable">
    <DTControl
      v-if="hasDTControl"
      :per-page-disabled="perPageDisabled"
      :per-page.sync="perPage"
    >
      <slot name="beside-per-page" slot="right-content" />
    </DTControl>
    <slot name="mid-content" />

    <b-table
      responsive
      bordered
      :striped="isStriped"
      hover
      show-empty
      :selectable="selectable"
      :select-mode="selectMode"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :tbodyTrClass="trClass"
      :small="isSmall"
      :fields="tblFields"
      :items="resources"
      :busy="isLoading"
      :per-page="perPage"
      :current-page="1"
      @row-selected="rowSelected"
      @row-clicked="rowClicked"
    >
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData" >
        <slot :name="name" v-bind="slotData" />
      </template>

      <template v-slot:empty>
        <div class="text-center my-5">
          <strong v-text="emptyString"></strong>
        </div>
      </template>

      <template v-slot:emptyfiltered>
        <div class="text-center my-5">
          <strong v-text="emptyFilteredString"></strong>
        </div>
      </template>

      <template v-slot:table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
    </b-table>

    <template v-if="hasPagination">
      <span v-show="!isLoading && totalPages > 0">
        Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong>
      </span>

      <b-pagination
        v-if="hasPagination"
        v-model="page"
        v-show="!isLoading"
        :total-rows="rows"
        :per-page="perPage"
        limit="3"
        first-text="<<"
        prev-text="Prev"
        next-text="Next"
        last-text=">>"
        class="float-md-right"
      />
    </template>
  </div>
</template>
<script>
import DTControl from '@/components/DatatableControl';

export default {
  name: 'Datatable',
  components: {
    DTControl,
  },
  props: {
    resources: {
      type: Array,
      default: () => ([]),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  // TODO: other properties for dynamic rendering of data
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      page: 1,
      perPageVal: 0,
    };
  },
  watch: {
    perPage(val) {
      this.$emit('update:perPage', val);
    },
    page(val) {
      this.$emit('updatePage', val);
    },
    sortBy(val) {
      const payload = {
        sortBy: val,
        sortDesc: this.sortDesc,
      };
      this.$emit('updateSort', payload);
    },
    sortDesc(val) {
      const payload = {
        sortBy: this.sortBy,
        sortDesc: val,
      };
      this.$emit('updateSort', payload);
    },
    currentPage(val) {
      this.page = val;
    },
  },
  computed: {
    dtOptions() {
      const options = this.$get(this, 'options', {});
      const otherOptions = this.$omit(options, ['dtControl']);
      return otherOptions;
    },
    hasDTControl() {
      const { dtControl } = this.options;
      return Boolean(dtControl);
    },
    trClass() {
      return this.$get(this.options, 'trClass', () => '');
    },
    isLoading() {
      return this.$get(this.options, 'loading', false);
    },
    tblFields() {
      return this.$get(this.options, 'fields', []);
    },
    currentPage() {
      return this.$get(this.options, 'currentPage', this.page);
    },
    perPage: {
      set(val) {
        this.perPageVal = val;
      },
      get() {
        return this.perPageVal || this.$get(this.options, 'perPage', 10);
      },
    },
    rows() {
      return this.$get(this.options, 'total', 0);
    },
    totalPages() {
      const total = this.$get(this.options, 'total', this.rows);

      return Math.ceil(total / this.perPage);
    },
    isSmall() {
      return this.$get(this.options, 'small', false);
    },
    hasPagination() {
      return this.$get(this.options, 'pagination', true);
    },
    emptyString() {
      return this.$get(this.options, 'emptyString', '-- NO DATA FOUND --');
    },
    emptyFilteredString() {
      return this.$get(this.options, 'emptyFilteredString', '-- NO DATA FOUND --');
    },
    selectable() {
      return this.$get(this.options, 'selectable', false);
    },
    selectMode() {
      return this.$get(this.options, 'selectMode', 'multi');
    },
    isStriped() {
      return this.$get(this.options, 'striped', true);
    },
    perPageDisabled() {
      return this.$get(this.options, 'perPageDisabled', false);
    },
  },
  methods: {
    updateSort(payload) {
      this.$emit('updateSort', payload);
    },
    rowSelected(payload) {
      this.$emit('row-selected', payload);
    },
    rowClicked(payload) {
      this.$emit('row-clicked', payload);
    },
  },
};
</script>
